<template>
  <div class="rating-list" style="padding: 10px;">
    <h3 style="font-size: 24px; margin-bottom: 20px">Média das avaliações: {{media.toFixed(1)}}</h3>
    <div class="box" v-for="(item, index) in items" :key="index">
      <article class="media">
        <div class="media-left">
          <figure class="image is-64x64">
            <img :src="getUserPicture(item.user)" alt="Image" class="is-rounded">
          </figure>
        </div>
        <div class="media-content">
          <div class="is-pulled-right">
            <pop-confirm
              content="Tem Certeza?"
              :on-ok="() => $emit('delete', item)"
              ok-text="Sim"
              cancel-text="Não"
            >
            <button class="button is-small is-danger">Apagar</button>
            </pop-confirm>
          </div>
          <div class="content">
            <p>
              <strong>{{item.user.firstName}} {{item.user.lastName}}</strong> <small>{{formatDate({ date: item.createdAt })}}</small>
              <br>
              {{item.message}}
            </p>
            <p>
              <small class="is-pulled-right"><b>Voto: </b> {{generateStars({ vote: item.vote })}}</small>
              <small>
                <b>Termos: </b>
                <span v-for="(t, i) in item.terms" :key="i" style="margin-right: 10px">
                  {{t}}
                </span>
              </small>
            </p>
          </div>
          <!-- <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item" aria-label="reply">
                <span class="icon is-small">
                  <i class="fa fa-reply" aria-hidden="true"></i>
                </span>
              </a>
              <a class="level-item" aria-label="retweet">
                <span class="icon is-small">
                  <i class="fa fa-retweet" aria-hidden="true"></i>
                </span>
              </a>
              <a class="level-item" aria-label="like">
                <span class="icon is-small">
                  <i class="fa fa-heart" aria-hidden="true"></i>
                </span>
              </a>
            </div>
          </nav> -->
        </div>
      </article>
    </div>
    <pagination
      v-if="Object.keys(paginationController).length > 0"
      :total="paginationController.total"
      :page-size="paginationController.limit"
      layout="pager"
      :change="(page) => $emit('change-page', page)"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RatingList',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    paginationController: {
      type: Object,
      default: () => {}
    },
    media: {
      type: Number,
      default: 0
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getUserPicture ({ avatarUrls }, size = '150x150') {
      return avatarUrls ? avatarUrls[size] : 'https://i.imgur.com/FEtJtdg.png'
    },
    generateStars ({ vote = 0, total = 5 }) {
      const dif = total - vote
      let stars = ''
      for (let i = 0; i < vote; i++) {
        stars += ' ★ '
      }
      for (let i = 0; i < dif; i++) {
        stars += ' ☆ '
      }
      return stars
    },
    formatDate ({ date, format = 'D/M/YYYY hh:mm' }) {
      return moment(date).format(format)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RatingList.vue